import { render, staticRenderFns } from "./jidi.vue?vue&type=template&id=278f5a58&"
import script from "./jidi.vue?vue&type=script&lang=js&"
export * from "./jidi.vue?vue&type=script&lang=js&"
import style0 from "./jidi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports